<template>
  <div class="auth-container">
    <h1>Reset password</h1>

    <form v-if="!isEmailSent" @submit.prevent="submit">
      <div class="form-group">
        <label>Email</label>
        <div class="input-wrapper">
          <input type="text" v-model.trim="formModel.email" placeholder="Email" autofocus />
        </div>
      </div>

      <div v-for="error in errors" :key="error" class="auth-error">
        {{ error }}
      </div>

      <div class="submit-group">
        <button :disabled="isSubmitDisabled" class="btn btn-blue">Send reset email</button>
      </div>
    </form>

    <div v-else class="reset-success">
      We have sent you instructions on how to reset your password by email.
      To restore access to your account, follow the link from the letter.
    </div>
  </div>
</template>

<script>
import { proccessError } from '@/helpers/utils';

export default {
  name: 'Reset',
  data: () => ({
    formModel: {
      email: '',
    },
    errors: [],
    isEmailSent: false,
    isSubmitDisabled: false,
  }),
  watch: {
    formModel: {
      handler() {
        this.errors = [];
      },
      deep: true,
    },
  },
  methods: {
    async submit() {
      this.isSubmitDisabled = true;

      try {
        await this.$store.dispatch('auth/sendResetEmail', this.formModel.email);
        this.isEmailSent = true;
      } catch (e) {
        this.isSubmitDisabled = false;
        this.errors = proccessError(e.response.data);
      }
    },
  },
};
</script>

<style lang="less" scoped>
  .reset-success {
    background-color: #7ce7f2;
    border-radius: 5px;
    padding: 15px;
    color: #202020;
    max-width: 400px;
  }
</style>
